import script from "./Partners.vue?vue&type=script&setup=true&lang=js"
export * from "./Partners.vue?vue&type=script&setup=true&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=1502d598&lang=css"

const __exports__ = script;

export default __exports__